export const ALL_GENDERS = [
    {
        value: 1,
        name: 'Male',
    },
    {
        value: 2,
        name: 'Female',
    },
    {
        value: 3,
        name: 'Other',
    },
];
